import isEmpty from 'lodash/isEmpty'
const scrollMonitor = require('scrollmonitor')

export default class ScrollAnimations {
    constructor() {
        this.cacheDom()
        this.init()
    }

    cacheDom() {
        this.elements = document.querySelectorAll('[data-animate]')
    }

    init() {
        if (!isEmpty(this.elements)) {
            Array.prototype.forEach.call(this.elements,(el, i) => {
                let entered = false
                const watchedItem = scrollMonitor.create(el, (window.innerHeight / 5) * -1)

                if (el.hasAttribute('data-delay')) {
                    el.style.transitionDelay = `${el.getAttribute('data-delay')}ms`
                }

                watchedItem.enterViewport(() => {
                    if (!entered) {
                        entered = true
                        el.classList.add('animate')
                    }
                })
            })
        }
    }

    getTransitionEndEventName() {
        const transitions = {
            'transition'      : 'transitionend',
            'OTransition'     : 'oTransitionEnd',
            'MozTransition'   : 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        }
        let bodyStyle = document.body.style
        for (let transition in transitions) {
            if(bodyStyle[transition] != undefined) {
                return transitions[transition]
            }
        }
    }
}